import DataSource from "devextreme/data/data_source";
import { useQuery } from "react-query";
import { atom, atomFamily } from "recoil";
import { loadFn, Params } from "shared/component/dxf-map/dxf-map";
import { client } from "shared/helpers/client";



// const bookingFilterAtom = atom({
//   key: "booking-filter",
//   default: {
//     skipCount: 0,
//     maxResultCount: '',
//     filter:{"StartDate":{"operator":"Equals","value":"2020-01-02 11:07:42.807"},"EndDate":{"operator":"Equals","value":"2022-01-02 11:16:03.377"}}
//   },
// });



export const getBookingOffice=(params: Params)=> {
  return client<any[]>('/OwnerBooking/getOfficeBooking', { params })
}

export const BookingOfficeSource = (officeId: number) => new DataSource({
    key:"id",
    load:loadFn(getBookingOffice,{officeId})
  })

  export const BookingOfficeSourceAtom = atomFamily({
    key: 'BookingOfficeSource',
    default: (officeId: any) => BookingOfficeSource(officeId),
    dangerouslyAllowMutability:true
    })
    